import React, { Component } from 'react';

import { RoutesContext } from '@confluence/route-manager/entry-points/RoutesContext.ts';

import { ReturnToMobileComponent } from './ReturnToMobileComponent.tsx';

export class ReturnToMobile extends Component {
	render(): React.JSX.Element {
		return (
			<RoutesContext.Consumer>
				{({ getQueryParams, setQueryParams }) => {
					return (
						<ReturnToMobileComponent
							getQueryParams={getQueryParams}
							setQueryParams={setQueryParams}
							{...this.props}
						/>
					);
				}}
			</RoutesContext.Consumer>
		);
	}
}
